module.exports = __webpack_public_path__ + "img/珠江帝景.33c5bfd3.png";